class Reading {
    constructor(
        id, 
        title,
        imageUri,
        link,
        orderAdded
    ) {
        this.id = id;
        this.title = title;
        this.imageUri = imageUri;
        this.link = link;
        this.orderAdded = orderAdded;
    }
}

export default Reading;